export const createRange = ({
  min,
  max,
  step,
}: {
  min: number;
  max: number;
  step: number;
}): number[] => {
  const range = [];
  for (let i = min; i <= max; i += step) {
    range.push(i);
  }
  return range;
};
